import * as Sentry from '@sentry/browser';

// Typography class patterns for handling bold states
export const TYPOGRAPHY_CLASS_PATTERN = 'typography--body-';
export const TYPOGRAPHY_BOLD_SUFFIX = '-bold';

/**
 * Aktualizuje třídu typografie elementu
 * Spravuje tučné/netučné stavy na základě aktivity
 * Hlásí chyby, pokud chybí elementy typografie
 *
 * @param element {HTMLElement} - Cílový element pro aktualizaci
 * @param isActive {boolean} - Zda je element aktivní
 * @returns {void}
 */
export const updateTypographyClass = (element: HTMLElement, isActive: boolean): void => {
  const typographyEl = element.querySelector('.typography') as HTMLElement;
  if (!typographyEl) {
    Sentry.captureException('Typografie: Element typografie nenalezen');
    return;
  }

  const typographyClass = Array.from(typographyEl.classList).find((className) =>
    className.startsWith(TYPOGRAPHY_CLASS_PATTERN)
  );

  if (!typographyClass) {
    Sentry.captureException('Typografie: Třída typografie nenalezena');
    return;
  }

  // Získání základní třídy bez tučného suffixu
  const baseClass = typographyClass.replace(TYPOGRAPHY_BOLD_SUFFIX, '');
  const newClass = `${baseClass}${isActive ? TYPOGRAPHY_BOLD_SUFFIX : ''}`;

  typographyEl.classList.remove(typographyClass);
  typographyEl.classList.add(newClass);
};
